<template>
    <b-container class="admin-device-verification text-left">
        <b-row>
            <b-col>
                <b-row class="admin-device-verification-title">
                    <b-col>{{$t('device_verification.title')}}</b-col>
                </b-row>
                <b-row>
                    <b-col>{{$t('device_verification.content')}}</b-col>
                </b-row>
                <b-row>
                    <b-col lg="6">
                        <b-form-input :placeholder="$t('device_verification.second_factor_code')"
                                      v-model="secondFactorCode"
                                      @keyup.enter="verify"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6">
                        <b-form-checkbox v-model="rememberDevice">
                            {{$t('device_verification.remember_device')}}
                        </b-form-checkbox>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col lg="3">
                        <b-button @click="verify" variant="primary" class="device-verification-btn">{{$t('continue')}}</b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faEnvelope} from '@fortawesome/free-regular-svg-icons'
    import {deviceVerificationErrorHandler} from "@/plugins/errorHandler";

    library.add(faEnvelope);

    export default {
        name: 'AdminDeviceVerification',
        components: {},
        data() {
            return {
                secondFactorCode: '',
                rememberDevice: false,
                after: this.$route.query.after,
                oauthNextUrl: this.$route.query.next
            };
        },
        watch: {
            currentUser(newVal, oldVal) {
                if (!oldVal.id && newVal.id) {
                    if (newVal.type == 0) {
                        // this.$showAlertMessage(this.$t('admin_login.not_admin'));
                        this.$storeDispatch('logout');
                    } else {
                        if (this.after) {
                            this.$router.replace({path: this.after});
                        } else {
                            this.$router.replace({name: 'admin'});
                        }

                    }
                }
            },
        },
        computed: {
            currentUser() {
                return this.$store.state.user;
            },
        },
        methods: {
            verify() {
                if (this.secondFactorCode) {
                    this.$callAPI('hkiarace/device_verify/', {second_factor_code: this.secondFactorCode, remember_device: this.rememberDevice}, function (response) {
                      if (this.oauthNextUrl) {
                        window.location.href = this.oauthNextUrl.startsWith("/")
                            ? window.location.origin + this.oauthNextUrl
                            : this.oauthNextUrl;
                      }
                      else {
                        this.$storeDispatch('getMe');
                      }
                    }, function (response) {
                      deviceVerificationErrorHandler(response, this);
                    });
                }
            },
        }
    }
</script>

<style lang="less">
    .admin-device-verification {
        padding: 24px;

        .admin-device-verification-title {
            font-weight: bold;
            font-size: 1.3rem;
        }

        .row {
            margin-bottom: 1rem;
        }

        .form-control {
            border-radius: 0;
            border: none;
            border-bottom: 1px solid #ced4da;
        }

        .device-verification-btn {
            width: 100%;
            background-color: #3b3a53;
            border-color: #3b3a53;
            color: white;
            font-weight: bold;
        }
    }
</style>